import createReducer, { mergeReducers } from "../../../lib/createReducer";
import {
  CONFIRM_JOB_ORDER_CONFIRMATION_ERROR,
  CONFIRM_JOB_ORDER_CONFIRMATION_REQUEST,
  CONFIRM_JOB_ORDER_CONFIRMATION_SUCCESS,
} from "./action";

const init = {
  job: null,

  isFetching: false,
  fetchSuccess: false,
  hasError: false,
  payload: null,
  error: null,
};

const requestReducer = createReducer(
  CONFIRM_JOB_ORDER_CONFIRMATION_REQUEST,
  ({ job }) => ({
    ...init,
    job,
    isFetching: true,
  }),
  true
);

const successReducer = createReducer(CONFIRM_JOB_ORDER_CONFIRMATION_SUCCESS, ({ response }) => ({
  isFetching: false,
  fetchSuccess: true,
  payload: response,
}));

const errorReducer = createReducer(CONFIRM_JOB_ORDER_CONFIRMATION_ERROR, ({ error }) => ({
  isFetching: false,
  hasError: true,
  error,
}));

export default mergeReducers([requestReducer, successReducer, errorReducer], init);
